import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './candlestickTilePreview.png';

export const candlestickTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The candlestick chart shows four price points (open, close,
                high, and low) throughout a specified period of time.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'candlestick-capsule-chart-preview',
        },
    ],
};
